import React from "react";
import {
  Button,
  Modal,
  Grid,
  Icon,
  Dropdown,
  Header,
  List,
} from "semantic-ui-react";
import { toastr } from "react-redux-toastr";
import { Form } from "formsy-semantic-ui-react";
import { dispatch } from "@rematch/core";

import ImageAvater from "../../../../drive/Components/ImageAvater";
import Labels from "../../../../common/Labels";
import EllipsisTooltip from "../../../../common/EllipsisTooltip";
class ChangeRoleModel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  close = () => {
    this.props.changeRole(false);
    this.setState({ selectedValue: undefined });
  };

  handleSaveChange =async () => {
    const newRole = {
      ...this.props.userdata,
      selectedValue: this.state.selectedValue,
      selectedOrganisation: this.props.currprops.selectedOrganisation,
    };
    if(this.state.selectedValue !== "workspaceOwner"){
      newRole.teamId = this.props.teamId;
    }
    await dispatch.organizationUnit.updateRole(newRole);
    this.props.changeRole(false);
    await dispatch.organizationUnit.showResourecePane(null);
    await dispatch.organizationTab.getUsersTreeAsync({
      id: this.props.teamId,
      accountId: this.props.currprops.selectedAccount._id,
    });
    toastr.success("Role Changed", "Role Changed successfully.");

    this.setState({ selectedValue: undefined });
  };

  updatedRole = async (e, value) => {
    await this.setState({ selectedValue: value.value });
  };

  render() {
    const { userdata } = this.props;

    const options = [
      // { key: 2, text: "Member", value: "Member" },
    ];
    if(this.props.selectedOrganisation.role === "workspaceOwner"){
      options.push({ key: 1, text: "WorkSpace Owner", value: "workspaceOwner" })
    }
    if(userdata && userdata.role === "Member"){
      options.push({ key: 3, text: "Manager", value: "Manager" })
    }

    return userdata ? (
      <Modal
        className="basicModal"
        open={this.props.open}
        size="small"
        closeOnEscape={false}
        closeOnDimmerClick={false}
        closeIcon
        onClose={this.close}
      >
        <Modal.Header>Change Role</Modal.Header>
        <Form
          noValidate
          ref={(ref) => (this.form = ref)}
          className="formcyForm"
          name="change"
          id="chanegRole"
          // onValidSubmit={this.createIssue}
        >
          <Modal.Content className="pad_20">
            <Grid>
              {/* first row   Header section*/}
              <Grid.Row className="pad_tb_4">
                <Grid.Column width={16}>
                  <Modal.Description>
                    <Header>
                      You are changing role for the following user
                    </Header>
                  </Modal.Description>
                </Grid.Column>
              </Grid.Row>

              {/* second row - name & icon */}
              <Grid.Row className="pad_tb_4">
                <Grid.Column width={16}>
                  <Labels
                    // name="Owner"
                    text={
                      <List horizontal>
                        <List.Item>
                          <ImageAvater user={userdata && userdata} />
                          <List.Content className="f_12">
                            <EllipsisTooltip
                              name={
                                userdata &&
                                userdata.firstName + " " + userdata.lastName
                              }
                              line={2}
                              style={{ lineHeight: "20px" }}
                            />
                          </List.Content>
                        </List.Item>
                      </List>
                    }
                  />
                </Grid.Column>
              </Grid.Row>

              {/* third row   dropdown section*/}
              <Grid.Row className="pad_tb_4">
                <Grid.Column width={7}>
                  <label>Current Role</label>
                  <Dropdown
                    clearable
                    fluid
                    disabled
                    search
                    selection
                    options={[]}
                    text={userdata.role}
                  />
                </Grid.Column>
                <Grid.Column width={2} textAlign="center">
                  <p style={{ marginBottom: "13px" }}></p>
                  <Icon disabled name="angle right" size="big" />
                  {/* <Icon disabled name="angle right" size="big" /> */}
                </Grid.Column>

                <Grid.Column width={7}>
                  <label>New Role</label>
                  <Dropdown
                    required
                    name="default"
                    selection
                    fluid
                    options={options}
                    placeholder="Select New Role"
                    onChange={(e, value) => {
                      this.updatedRole(e, value);
                    }}
                  />
                </Grid.Column>
              </Grid.Row>

              {/* fourth row notes section  */}
              <Grid.Row className="pad_tb_4">
                <Grid.Column width={16}>
                  {/* <br /> */}
                  {/* roles */}
                  <Grid.Row className="mar_tb_10">
                    <p className="mar_0_auto">
                      <strong>Roles</strong>
                    </p>
                    <p className="mar_0_auto">Workspace Owner</p>
                    <p className="mar_0_auto">Administrator for Workspace.</p>
                    <p className="mar_0_auto">
                      Can have multiple Workspace Owners per Workspace.
                      Abbreviated to WSO.
                    </p>
                  </Grid.Row>

                  {/* manager */}
                  <Grid.Row className="mar_tb_10">
                    <p className="mar_0_auto">
                      <strong>Manager</strong>
                    </p>
                    <p className="mar_0_auto">Manager of a team.</p>
                    <p className="mar_0_auto">
                      Capable of managing users and teams in addition to
                      playbooks, content and initiatives.
                    </p>
                  </Grid.Row>

                  {/* User */}

                  <Grid.Row className="mar_tb_10">
                    <p className="mar_0_auto">
                      <strong>User</strong>
                    </p>
                    <p className="mar_0_auto">General user of the workspace.</p>
                    <p className="mar_0_auto">
                      Only able to create playbooks, content and participating
                      in initiatives.
                    </p>
                  </Grid.Row>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Content>
          <Modal.Actions className="actionInFormcy">
            <Button
              content="Cancel"
              className="button-cancel"
              onClick={this.close}
            />

            <Button
              type="submit"
              content="Save"
              disabled={this.state.selectedValue ? false : true}
              onClick={this.handleSaveChange}
              className="button-submit"
            />
          </Modal.Actions>
        </Form>
      </Modal>
    ) : null;
  }
}

export default ChangeRoleModel;
